import DatePicker, { registerLocale } from './date_picker.jsx';

export default DatePicker;
export { registerLocale };
